<template>
  <div v-if="showFloatBtn"
       class="consult-entrance-float-btn-component"
       @click="handleConsultDetail"
  >
    <ym-img :src="require('@/assets/img/consult/consult_entrance.png')"
            alt="咨询客服"
    />
  </div>
</template>

<script>
  import { getCourseLivingFloatBtnInfo } from '@/services/course';

  export default {
    name: 'ConsultEntranceFloatBtn',
    data() {
      return {
        list: [],
      };
    },
    props: {
      targetId: {
        type: Number,
        required: true,
      },
      targetType: {
        type: String,
        required: true,
      },
      showConsult: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      showFloatBtn() {
        return this.showConsult && !this.list.length > 0;
      },
    },
    methods: {
      async getCourseLivingFloatBtnInfo() {
        const data = await getCourseLivingFloatBtnInfo();
        this.list = data.list;
      },
      handleConsultDetail() {
        const route = {
          name: 'CustomerService',
          params: { id: this.targetId, type: this.targetType },
        };
        this.$router.push(route);
      },
    },
    created() {
      this.getCourseLivingFloatBtnInfo();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .consult-entrance-float-btn-component {
    width: @float-btn-width;
    height: @float-btn-height;
    position: fixed;
    left: 50%;
    margin-left: 750/2 - @float-btn-width - @float-btn-right;
    bottom: @consult-float-btn-bottom;
    z-index: @z-index-extra-extra-large;
    img {
      width: 100%;
      height: 100%;
    }
  }

</style>
